import React from "react";
import styled from "styled-components";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import colors from "constants/palette";

const Container = styled.div`
  margin-top: 12px;
  width: 210px;
  & .ant-input-affix-wrapper,
  .ant-input-affix-wrapper-lg {
    background: ${colors.white + "40"};
  }
  & input::placeholder {
    color: ${colors.dark + "bc"};
  }
  & input {
    color: ${colors.dark};
    background-color: transparent;
  }

  & span {
    color: ${colors.dark};
    fill: ${colors.dark};
  }
`;

export default function App(props) {
  return (
    <Container>
      <Search
        allowClear={true}
        suffix={<SearchIcon />}
        size="large"
        {...props}
      />
    </Container>
  );
}

const Search = styled(Input)`
  border-radius: 24px;
`;
const SearchIcon = styled(SearchOutlined)`
  & svg {
    transition: all ease-in-out 0.2s;
  }
  & svg:hover {
    color: ${colors.blue};
    cursor: pointer;
  }
`;
